import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GroupsIcon from "@mui/icons-material/Groups";
import InsightsIcon from "@mui/icons-material/Insights";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MedicationIcon from "@mui/icons-material/Medication";
import PaidIcon from "@mui/icons-material/Paid";
import ScienceIcon from "@mui/icons-material/Science";
import SecurityIcon from "@mui/icons-material/Security";
import VaccinesIcon from "@mui/icons-material/Vaccines";

export const brand = {
  name: "VetCastle",
  company: "MayimDazzle India Private Limited",
  companyUrl: "https://mayimdazzle.com",
  primary: "#15585e",
  ink: "#071716",
  meadow: "#dff56a",
  sand: "#f7f2e8",
  mint: "#e6f2ea"
};

export const publicNavItems = [
  { label: "Home", path: "/" },
  { label: "Features", path: "/features" },
  { label: "Pricing", path: "/pricing" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" }
];

export const featureCards = [
  {
    icon: CalendarMonthIcon,
    title: "Appointment Management",
    text: "Online booking, receptionist scheduling, doctor queues, status transitions, and appointment history."
  },
  {
    icon: LocalHospitalIcon,
    title: "Clinical Records",
    text: "Visit notes, SOAP records, diagnosis, prescriptions, and patient history organized around each visit."
  },
  {
    icon: ScienceIcon,
    title: "Lab Tracking",
    text: "Lab requests, status updates, result attachment, and pet-owner-accessible reports."
  },
  {
    icon: VaccinesIcon,
    title: "Vaccination Intelligence",
    text: "Species-aware schedules, due alerts, overdue lists, and vaccination history for each pet."
  },
  {
    icon: PaidIcon,
    title: "Billing & Invoicing",
    text: "Invoice creation, itemized billing, payments, balances, and downloadable PDFs."
  },
  {
    icon: Inventory2Icon,
    title: "Inventory & Pharmacy",
    text: "Products, batches, stock receiving, deductions, low-stock alerts, and prescription dispensing."
  },
  {
    icon: GroupsIcon,
    title: "Multi-Branch Management",
    text: "Tenant-safe hospital, branch, staff, doctor, receptionist, pharmacist, and owner workflows."
  },
  {
    icon: SecurityIcon,
    title: "Role-Based Access",
    text: "Default-deny RBAC for doctors, receptionists, pharmacists, pet owners, and administrators."
  }
];

export const workflowSteps = [
  "Appointment",
  "Visit",
  "Diagnosis",
  "Prescription",
  "Lab",
  "Billing"
];

export const dashboardPreviews = [
  {
    title: "Doctor Dashboard",
    metric: "12 today",
    detail: "Appointments, active visits, lab queue, and patient history shortcuts."
  },
  {
    title: "Admin Dashboard",
    metric: "Rs 82k",
    detail: "Revenue, staff activity, inventory alerts, and appointment volume."
  },
  {
    title: "Pet Owner Dashboard",
    metric: "3 pets",
    detail: "Upcoming visits, invoices, vaccination alerts, and medical history."
  }
];

export const detailedFeatures = [
  {
    icon: FactCheckIcon,
    title: "Clinical System",
    points: ["Visit-centered medical records", "SOAP notes and diagnosis workflows", "Prescription lifecycle and patient history"]
  },
  {
    icon: PaidIcon,
    title: "Billing System",
    points: ["Invoice items, taxes, discounts, and payments", "PDF invoice export", "Owner and pet-linked billing records"]
  },
  {
    icon: Inventory2Icon,
    title: "Inventory System",
    points: ["Product catalog and batch tracking", "Stock receive and deduction flows", "Low-stock and pharmacy queue visibility"]
  },
  {
    icon: VaccinesIcon,
    title: "Vaccination Intelligence",
    points: ["Species and age-aware schedule logic", "Due and overdue suggestions", "Vaccination history by patient"]
  },
  {
    icon: InsightsIcon,
    title: "Reports & Analytics",
    points: ["Clinic dashboards by role", "Operational reports", "Revenue and workload snapshots"]
  },
  {
    icon: MedicationIcon,
    title: "Pharmacy Workflow",
    points: ["Prescription queue", "Dispense-ready stock context", "Batch-aware inventory deductions"]
  }
];

export const pricingPlans = [
  {
    name: "Starter",
    price: "Rs 2,999",
    period: "/month",
    description: "For single-clinic teams moving away from spreadsheets.",
    features: ["1 branch", "Up to 5 users", "Appointments and pets", "Basic invoices", "Email support"]
  },
  {
    name: "Professional",
    price: "Rs 7,999",
    period: "/month",
    description: "For growing hospitals that need full clinical and inventory workflows.",
    highlighted: true,
    features: ["Multi-role dashboards", "Clinical records and labs", "Vaccination intelligence", "Inventory and pharmacy", "Priority support"]
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "For multi-branch veterinary groups with advanced controls.",
    features: ["Multiple branches", "Custom onboarding", "Advanced RBAC", "Data migration assistance", "Dedicated success manager"]
  }
];
